// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"980px","desktopWidth":"1920px","bottom":"verifyPhone_bottom__7EbMI","btn":"verifyPhone_btn__1CRLB","msgText":"verifyPhone_msgText__Fbuv6"};